import Swiper from 'swiper/js/swiper.min';
import 'magnific-popup';
import 'jquery-ui';

const $win = $(window);
const $doc = $(document);
const $body = $('body');

/**
 * Accordion animation
 */

$('.accordion .accordion__head').on('click', function(e) {
	const $currentTarget = $(this).closest('.accordion__section');

	$currentTarget
		.find('.accordion__body')
			.slideToggle()
			.toggleClass('hidden')
			.end()
		.siblings()
			.find('.accordion__body')
				.slideUp()
				.addClass('hidden');
				
	window.dispatchEvent(new Event('resize'));
	console.log("a12345");
});

$('.form-filters .form__head').on('click', function() {
	$('.form-filters').toggleClass('active');
})

function navClick() {
	$('.nav').on('click', 'a', function(e){
		let parentEl = $(this).closest('li');
		let subMenu = $(this).closest('li').children('ul');

		parentEl.siblings().removeClass('hovered');

		if ( !parentEl.hasClass('hovered') && isMobile.any() && $win.width() <= 1024 && subMenu.length > 0 ) {
			e.preventDefault();

			parentEl.addClass('hovered');
		};
	});
}

var scrollTop = 0;
  $(window).scroll(function(){
	scrollTop = $(window).scrollTop();
	 // $('.counter').html(scrollTop);

	if (scrollTop >= 150) {
	  $('.actions').addClass('scrolled-actions');
  } else if (scrollTop < 150) {
	  $('.actions').removeClass('scrolled-actions');
	}
});

/**
 * Footer trigger
 */

$('.footer__content-trigger').on('click', function(e) {
	e.preventDefault();

	$('.footer').toggleClass('footer--active');
});

/**
 *  Mobile navigation
 */

$('.nav-trigger').on('click', function (e) {
	 e.preventDefault();

	 $body.addClass('has-active-nav');
});

$('.actions__hidden').on('click', function () {
	 $body.addClass('has-active-nav');
});

$('.nav__close').on('click', function(e) {
	e.preventDefault();

	$body.removeClass('has-active-nav');
});

$win.on('load resize', function() {
	initSliders();
});


$('.booking-btn').on('click', function(e){

	$("div.book-button-wrap2").toggle();
	if(!$(".book-button-wrap2 .minus").length){
		$("#guests").before('<span id="guests_minus" onclick="minus_guest(this);" class="minus noselect">-</span>');
	}
	if(!$(".book-button-wrap2 .plus").length){
		$("#guests").after('<span id="guests_plus" onclick="plus_guest(this);"  class="plus noselect">+</span>');
	}

});


$('.close-reveal-modal').on('click', function(e){
	$("div.book-button-wrap2").hide();
});
/**
 * Open popup gallery
 */

$('.js-gallery').on('click', function(e) {
	e.preventDefault();

	const target = $(this).attr('href');
	const $gallery = $(target);
	const images = $gallery.find('a');
	const items = [];

	images.each((i, image) => {
		const src = $(image).attr('href');

		items.push({
			src,
			type: 'image'
		})
	});

	$.magnificPopup.open({
		items,
			gallery: {
			enabled: true
		},
	});
});

const initSliders = () => {


	$('.js-slider-home .swiper-container').each((i, slider) => {
		const $container = $(slider).closest('.js-slider-home');
		const nextEl = $container.find('.slider__btn--next');
		const prevEl = $container.find('.slider__btn--prev');

		const swiper = new Swiper(slider, {
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 3000,
			autoplay: {
				delay: 3000,
			},
			loop: true,
			navigation: {
				nextEl,
				prevEl,
			},
			breakpoints: {
				667: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 1,
				},
				1024: {
					slidesPerView: 1,
				},

				1201: {
					slidesPerView: 1,
				},
			}
		});
	});

	/**
	 * Slider Offers
	 */

	$('.js-slider-offers .swiper-container').each((i, slider) => {
		const $container = $(slider).closest('.js-slider-offers');
		const nextEl = $container.find('.slider__btn--next');
		const prevEl = $container.find('.slider__btn--prev');
		const paginationEl = $container.find('.swiper-pagination');

		const swiper = new Swiper(slider, {
			slidesPerView: 1,
			spaceBetween: 30,
			loop: true,
			speed: 3000,
			autoplay: {
				delay: 3000,
			},
			pagination: {
				el: paginationEl,
				type: 'progressbar',
			},
			navigation: {
				nextEl,
				prevEl,
			},
			breakpoints: {
				667: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 20,
				},

				1201: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
			}
		});
	});

	/**
	 * Slider Offers
	 */

	$('.js-slider-plans .swiper-container').each((i, slider) => {
		const $container = $(slider).closest('.js-slider-plans');
		const nextEl = $container.find('.slider__btn--next');
		const prevEl = $container.find('.slider__btn--prev');

		const swiper = new Swiper(slider, {
			direction: 'vertical',
			slidesPerView: 1,
			allowTouchMove: false,
			speed: 600,
			pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
			},
			navigation: {
				nextEl,
				prevEl,
			},
		});
		
	});


	/**
	 * Slider Gallery
	 */

	$('.js-slider-gallery .swiper-container').each((i, slider) => {
		const $container = $(slider).closest('.js-slider-gallery');
		const nextEl = $container.find('.slider__btn--next');
		const prevEl = $container.find('.slider__btn--prev');

		const swiper = new Swiper(slider, {
			slidesPerView: 1,
			speed: 600,
			loop: true,
			navigation: {
				nextEl,
				prevEl,
			},
		});
	});

	/**
    * Slider Callout
    */

   $('.js-slider-callout .swiper-container').each((i, slider) => {
     const $container = $(slider).closest('.js-slider-callout');
     const nextEl = $container.find('.slider__btn--next');
     const prevEl = $container.find('.slider__btn--prev');
	 const paginationEl = $container.find('.swiper-pagination');
	 console.log("asdasd");
     new Swiper(slider, {
        slidesPerView: 1,
		spaceBetween: 30,
		loop: true,
		pagination: {
				el: paginationEl,
				type: 'progressbar',
			},
		navigation: {
			nextEl,
			prevEl,
		},
	   speed: 1000,
	   autoplay: {
			delay: 1000,
	   },
	   breakpoints: {
			667: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 20,
			},

			1201: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
		}
     });
   });

	 /**
	* Slider Reviews Page
	*/

	$('.js-slider-reviews-page .swiper-container').each((i, slider) => {
		const $container = $(slider).closest('.js-slider-callout');
		const nextEl = $container.find('.slider__btn--next');
		const prevEl = $container.find('.slider__btn--prev');
		
		const swiper = new Swiper(slider, {
			slidesPerView: 1,
			spaceBetween: 0,
			loop: true,
			pagination: {
				el: paginationEl,
				type: 'progressbar',
			},
			speed: 1000,
			autoplay: {
					delay: 1000,
			},
			navigation: {
				nextEl,
				prevEl,
			},
			breakpoints: {
				667: {
					slidesPerView: 2,
					spaceBetween: 25,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 40,
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 60,
				},
			}
		});
	});


   if ($win.width() >= 1024) { 

		/**
		 * Slider Booking
		 */

		$('.js-slider-bookign .swiper-container').each((i, slider) => {
			const $container = $(slider).closest('.js-slider-bookign');
			const nextEl = $container.find('.slider__btn--next');
			const prevEl = $container.find('.slider__btn--prev');
			const $btnText = nextEl.find('span');

			const swiper = new Swiper(slider, {
				slidesPerView: 1,
				spaceBetween: 120,
				loop: true,
				navigation: {
					nextEl,
					prevEl,
				},
				on: {
					transitionEnd() {
						const year = this.slides[this.activeIndex].dataset.year;

						$btnText.html(year);
					},
				},
			});
		});
   }

   if ($win.width() < 1024) { 
		/**
		 * Slider booking mobile
		 */

		$('.js-bookign .swiper-container').each((i, slider) => {
			const $container = $(slider).closest('.js-bookign');
			const nextEl = $container.find('.slider__btn--next');
			const prevEl = $container.find('.slider__btn--prev');
			const $btnText = nextEl.find('span');

			const swiper = new Swiper(slider, {
				slidesPerView: 1,
				loop: true,
				navigation: {
					nextEl,
					prevEl,
				},
				on: {
					transitionEnd() {
						const year = this.slides[this.activeIndex].dataset.year;

						$btnText.html(year);
					},
				},
				breakpoints: {
					667: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 35,
					},

					1201: {
						slidesPerView: 3,
						spaceBetween: 120,
					}
				}
			});
		});

	}
}


/**
 * Initialize datepicker
 */

$('.datepicker').datepicker();

/**
 * Quanity
 */

 $('.quantity__actions .quantity__btn').on('click', function(e) {
 	e.preventDefault();

 	const $btn = $(this);
 	const $field = $btn.closest('.quantity').find('input');
 	let fieldValue = parseInt($field.val());

 	if ( $btn.is('.quantity__btn--plus')) {
 		fieldValue ++;
 	}

 	if ( $btn.is('.quantity__btn--minus')) {
 		fieldValue --;
 	}

 	$field.val(fieldValue > 0 ? fieldValue : 0);
 });


 $('body').on( 'change', '#chalets-filter-form', function( event ) {

 	var choices = {};
 	$('.chalet-list').empty();

 	$('option:selected').each(function() {
 		if (!choices.hasOwnProperty(this.name))
 			choices[this.name] = [this.value];
 		else
 			choices[this.name].push(this.value);
 	});

 	// console.log(choices);
 	jQuery.ajax({
 		url: '/wordpress/wp-admin/admin-ajax.php',
 		type :'GET',
 		data : {
 			'action' : 'call_post', // Name of the PHP function
 			'choices' : choices,
 		},
 		success: function (result) {
 			$('.chalet-list').append(result);
 			// For testing - Result (Can be deleted later)
 			console.log(result);
 			console.log(choices);
 		},
 		error: function(err){
 			// For testing - Error (Can be removed later)
 			console.log(err);
 			console.log(choices);
 		}
 	});

 });

